import styled from 'styled-components';
import { sizes } from 'style';
import { colors } from 'style/theme';

import { H1 } from 'components/Typography';

export const Waves = styled.div`
  height: 200px;
  background-color: ${colors.white};
  width: 100%;
`;

export const Header = styled(H1)`
  position: absolute;
  margin: 100px 0 0 20px;
  color: ${colors.white};

  @media ${sizes.tabletPortrait} {
    margin: 100px 0 0 40px;
  }

  @media ${sizes.desktop} {
    margin: 100px 0 0 80px;
  }
`;

export const Svg = styled.svg`
  width: 100%;
  margin-top: 55px;
  position: absolute;
`;
